import React from "react";
import ReactFC from "react-fusioncharts";
import FusionCharts from "fusioncharts/core";
import Column2D from "fusioncharts/charts";
import FusionTheme from "fusioncharts/themes/es/fusioncharts.theme.fusion";
import { indicatorAnalysisOptions } from "utils/constant";
import { buildChartDataSource } from "./jentikTrend";

ReactFC.fcRoot(FusionCharts, Column2D, FusionTheme);

const JentikTrendChart = ({ data, indicator, levelIdSelected }) => {
  if (indicator === "indikator_32" && (!data || data.length === 0)) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: 300,
          color: "#888",
          fontSize: "1.1rem",
        }}
      >
        <p>Tidak ada data</p>
      </div>
    );
  }

  const indicatorName =
    indicatorAnalysisOptions.find((o) => o.value === indicator)?.label || "";

  const dataSource = buildChartDataSource(indicator, data, {
    indicatorName,
    levelIdSelected,
  });

  return (
    <div style={{ width: "100%", marginTop: "1rem" }}>
      <ReactFC
        type="mscombidy2d"
        width="100%"
        height="600"
        dataFormat="json"
        dataSource={dataSource}
      />
    </div>
  );
};

export default JentikTrendChart;
